import common from "../common";
import Scene from "./Scene";
import {calcLeftEdge, isCordova, randomSeed, translate} from "../utils";
import Carousel from "../ui/carousel/Carousel";
import SceneTitlePanel from "../ui/SceneTitlePanel";

export default class LearnScene extends Scene {

    constructor() {
        super();
    }

    init() {
        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture("bg_main"));
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_secondary_up");
        states.icon = P3.assets.texture("icon_back");

        this._backButton = new P3.Button(states);
        this._backButton.signals.click.add(this._onBackButtonClick, this);
        this.addChild(this._backButton);

        this._sceneTitle = new SceneTitlePanel(translate("learn"));
        this._sceneTitle.position.set(common.STAGE_WIDTH / 2, 120);
        this.addChild(this._sceneTitle);
    }

    resize() {
        super.resize();
        this._backButton.position.set(calcLeftEdge() + 90, 90);
    }

    animateIn() {

    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update(dt = window.deltaTime) {
        super.update();

        //this._carousel.update(dt);
    }

    end() {
        // this.signals.next.dispatch();
    }

    _onPlayButtonClick() {
        //window.open(this._carousel.selected.url, randomSeed());
        //window.open(this._carousel.selected.url, "_blank");
    }

    _onBackButtonClick() {
        this.signals.previous.dispatch();
    }
}